module.exports = __webpack_public_path__ + "media/promo/promo/images/callback-366723535ab4e5a87bf05e1aff8ba035.svg";